import { useLocation } from 'react-router-dom';
import {
  VIEW_MORE_RECENT_ORDER, // confirm exact constant
  VIEW_MORE_RECENT_FAVORITE_ORDER,
  ROUTE_THANK_YOU, // include only if allowed
  ROUTE_ORDER_TRACKING,
} from '../constants';
import useCheckMobileScreen from './useCheckMobileScreen';
import { useAppSelector } from '../redux/store/store';
import { useIsDesignV2 } from './useIsDesignV2';

export default function useTrackBarVisibility() {
  const location = useLocation();
  const isMobile = useCheckMobileScreen();
  const isDesignV2 = useIsDesignV2();
  const trackOrder = useAppSelector(s => s.checkout?.trackOrder);
  const cart = useAppSelector((state) => state.cart);
  

  const allowedRoutes = new Set<string>([VIEW_MORE_RECENT_ORDER, VIEW_MORE_RECENT_FAVORITE_ORDER]);
  const onAllowedRoute = allowedRoutes.has(location.pathname);
  const onThankYouPage = location.pathname === ROUTE_THANK_YOU;
  const onOrderTrackingPage = location.pathname.includes(ROUTE_ORDER_TRACKING);

  // Only show when trackOrder is true AND route is Recent Orders
  // keep any global suppressors here (so future tweaks are one-line changes)
  if(isDesignV2){
    return Boolean(trackOrder) && onAllowedRoute && !cart?.showCart;
  }else if(onThankYouPage || onOrderTrackingPage){
    return false;
  }else {
    return trackOrder;
  }
}
